import { render, staticRenderFns } from "./MmfUploadModal.vue?vue&type=template&id=616abd37&"
import script from "./MmfUploadModal.vue?vue&type=script&lang=js&"
export * from "./MmfUploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports